import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";

import { ERRORS } from "../../constants";
import { storeNewCampaign } from "../../apis/firebase";

enum FORM_STATE {
  IDLE,
  IN_PROGRESS,
  ERROR,
}

export default function CampaignNew() {
  const [title, setTitle] = useState("");
  const [formState, setFormState] = useState<FORM_STATE>(FORM_STATE.IDLE);
  const history = useHistory();
  const ready = title !== "";

  async function onSubmit(e) {
    e.preventDefault();
    try {
      setFormState(FORM_STATE.IN_PROGRESS);
      const res = await storeNewCampaign(title);
      history.push(`/campaigns/edit/${res.id}/content`);
    } catch (err) {
      if (err.message === ERRORS.NO_AUTHENTICATION) {
        history.push("/login");
        return;
      }
      console.error(err);
      setFormState(FORM_STATE.ERROR);
    }
  }

  return (
    <div className="layout mt3">
      <form onSubmit={onSubmit} className="rel">
        <input
          value={title}
          type="text"
          placeholder="Your title here"
          onChange={(e) => setTitle(e.target.value)}
          autoFocus
          disabled={formState === FORM_STATE.IN_PROGRESS}
        />
        <div className="mt1">
          {formState === FORM_STATE.ERROR && (
            <div className="error mb1">
              ✖ There is a problem saving your post.
            </div>
          )}
          <button
            type="submit"
            className="primary"
            disabled={!ready || formState === FORM_STATE.IN_PROGRESS}
          >
            {formState === FORM_STATE.IN_PROGRESS ? "Saving..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
